/**
 * TEST COMPARISON SERVICE
 * TEMPORARY - FOR DEMONSTRATION PURPOSES ONLY
 * TO BE REMOVED AFTER MANAGER REVIEW
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

class TestComparisonService {
  /**
   * Get test comparison images from backend
   * @returns {Promise<Object>} Test comparison data
   */
  async getTestComparisonImages() {
    try {
      console.log('🧪 TEST: Fetching test comparison images...');
      
      const response = await fetch(
        `${API_BASE_URL}/api/test/comparison-images`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ TEST: Test images loaded successfully');
      return data;
    } catch (error) {
      console.error('❌ TEST: Failed to load test images:', error);
      throw new Error(error.message || 'Failed to load test comparison images');
    }
  }

  /**
   * Analyze test images using Gemini AI - Comprehensive Approach
   * @param {Object} comparisonData - Comparison data with images
   * @returns {Promise<Object>} AI analysis results
   */
  async analyzeTestComprehensive(comparisonData) {
    try {
      console.log('🧪 TEST: Starting comprehensive AI analysis...');
      
      const requestPayload = {
        image1_base64: comparisonData.comparison.image1.preview_base64,
        image2_base64: comparisonData.comparison.image2.preview_base64,
        latitude: comparisonData.comparison.location.latitude,
        longitude: comparisonData.comparison.location.longitude,
        date1: comparisonData.comparison.image1.actual_date,
        date2: comparisonData.comparison.image2.actual_date,
        days_between: comparisonData.comparison.comparison.days_between
      };
      
      const response = await fetch(
        `${API_BASE_URL}/api/test/analyze-comprehensive`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestPayload),
          signal: AbortSignal.timeout(180000) // 3 minutes timeout
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ TEST: Comprehensive analysis complete');
      return data.analysis;
    } catch (error) {
      console.error('❌ TEST: Comprehensive analysis failed:', error);
      throw new Error(error.message || 'Failed to perform comprehensive analysis');
    }
  }

  /**
   * Analyze test images using Gemini AI - Segmentation Approach
   * @param {Object} comparisonData - Comparison data with images
   * @returns {Promise<Object>} AI segmentation analysis results
   */
  async analyzeTestSegmentation(comparisonData) {
    try {
      console.log('🧪 TEST: Starting segmentation AI analysis...');
      
      const requestPayload = {
        image1_base64: comparisonData.comparison.image1.preview_base64,
        image2_base64: comparisonData.comparison.image2.preview_base64,
        latitude: comparisonData.comparison.location.latitude,
        longitude: comparisonData.comparison.location.longitude,
        date1: comparisonData.comparison.image1.actual_date,
        date2: comparisonData.comparison.image2.actual_date,
        days_between: comparisonData.comparison.comparison.days_between
      };
      
      const response = await fetch(
        `${API_BASE_URL}/api/test/analyze-segmentation`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestPayload),
          signal: AbortSignal.timeout(180000) // 3 minutes timeout
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ TEST: Segmentation analysis complete');
      return data.analysis;
    } catch (error) {
      console.error('❌ TEST: Segmentation analysis failed:', error);
      throw new Error(error.message || 'Failed to perform segmentation analysis');
    }
  }
}

export default new TestComparisonService();

